import "core-js/modules/es.error.cause.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validateSalaryLastWf, validateWelfareFundRatio } from './welfare-fund-validate';
export default {
  name: 'fund-welfare',
  props: {
    staffInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    amountRules: function amountRules() {
      return [this.buildAmountRule(validateSalaryLastWf, this.$t('24916_6c7161c7', {
        min: 0,
        max: 1000000000,
        x: 2
      }))];
    },
    ratioRules: function ratioRules() {
      if (this.staffInfo.welfare_fund_status === '2') return [];
      return [this.buildAmountRule(validateWelfareFundRatio, this.$t('24916_6c7161c7', {
        min: 0.01,
        max: 100,
        x: 2
      }))];
    }
  },
  methods: {
    buildAmountRule: function buildAmountRule(validate, invalidMessage) {
      var _this = this;
      return {
        required: true,
        trigger: 'blur',
        validator: function validator(rule, value, callback) {
          var result = validate(value);
          if (result === 'ok') return callback();
          callback(new Error(result === 'empty' ? _this.$t('1593') : _this.$t(invalidMessage)));
        }
      };
    }
  }
};